import { render } from "./add-serve-category-dialog.vue?vue&type=template&id=42e0ddb9&scoped=true"
import script from "./add-serve-category-dialog.vue?vue&type=script&lang=js"
export * from "./add-serve-category-dialog.vue?vue&type=script&lang=js"

import "./add-serve-category-dialog.vue?vue&type=style&index=0&id=42e0ddb9&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e0ddb9"]])

export default __exports__